<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="业务单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="datetime" label="下单时间" start-name="create_begin_time" end-name="create_end_time"></c-form-item>
                    <c-form-item type="datetime" label="支付时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<c-form-item type="checkbox" label="类型" name="order_types" :options="orderTypeOptions"></c-form-item>
					<c-form-item type="checkbox" label="销售方式" name="order_classify" :options="orderClassify"></c-form-item>
					<c-form-item type="checkbox" label="清分状态" name="state" :options="state" ></c-form-item>
				</c-form>
			</m-search>
			<m-operate>
				<c-button @click="exportData()" icon="export">导出清分明细</c-button>
			</m-operate>
			<c-table ref="table">
				
				<c-table-column
					label="业务单号"
					name="order_number"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="会员信息 "
					name="nick_name"
					width="250"
				>
					<template v-slot="row">
						{{row.data.nick_name}}【<font color="#999">{{row.data.user_manage_mobilephone||'-'}}</font>】
					</template>
				</c-table-column>
				
				<c-table-column
					label="类型"
					name="order_type"
					width="100"
				>
					<template v-slot="row">
						<span v-if="row.data.order_type==10" style="color:blue">充值升级</span>
						<span v-else-if="row.data.order_type==11" style="color:#ff00ff">货款充值</span>
						<span v-else>销售订单</span>
					</template>
				</c-table-column>

				<c-table-column
					label="销售方式"
					name="order_classify"
					width="80"
				>
					<template v-slot="row">
						<span v-if="row.data.order_classify==1" style="color:green">供货</span>
						<span v-else-if="row.data.order_classify==2" style="color:#0000ff">直销</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="实付金额（不计运费）"
					name="payment_money"
					width="150"
				>
					<template v-slot="row">
					    {{'¥'+parseFloat(row.data.payment_money).toFixed(2)}}
					</template>
				</c-table-column>

				<c-table-column
					label="奖励金额"
					name="reward_money"
					width="100"
				>
					<template v-slot="row">
						<span v-if="row.data.record_money">{{'¥'+parseFloat(row.data.record_money).toFixed(2)}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="解冻金额"
					name="back_product_money"
					width="100"
				>
					<template v-slot="row">
					    <span v-if="row.data.back_product_money">{{'¥'+parseFloat(row.data.back_product_money).toFixed(2)}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column> -->

				<c-table-column
					label="清分状态"
					name="state"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
						<span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
						<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="下单时间"
					name="create_date"
					width="150"
				></c-table-column>

				<c-table-column
					label="支付时间"
					name="payment_date"
					width="150"
				>
                    <template v-slot="{data}">
                        <span v-if="data.payment_date">{{data.payment_date}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/reward/detail/${data.order_number}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_reward_settlement',
		
		data() {
			return {
				transStateName: {
					0: '取消清分',
					1: '待清分',
					2: '已经清分',
				},
				orderTypeOptions: [{
				    name:'充值升级',
				    value: 10
				  },{
				    name:'货款充值',
				    value: 11
				  },{
				    name:'销售订单',
				    value: 1
				  }],
				orderClassify: [{
				    name:'供货',
				    value: 1
				  },{
				    name:'直销',
				    value: 2
				  }],
				state: [{
						name: '待清分',
						value: 1
					},{
						name: '取消清分',
						value: 0
					},{
						name: '已经清分',
						value: 2
					}
				]
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.searchDate = data;
				this.$refs.table.load({
					url: '/reward/record/list',
					data
				});
			},
			//批量导出清分明细
			exportData() {
				var data = this.searchDate;
				data.job_id = 40;
				this.request({
					url: '/export_job/add',
					data: data,
					loading: true,
					success: data => {
						this.$message({
							text: '订单导出任务提交成功，请稍后前往任务中心查看',
							icon: 'success'
						});
					}
				});
				
			},
		}
	}
</script>